{
  "title": "Create the first account",
  "lead": "You become the owner of this CloudServer installation.",
  "code": "Setup code",
  "codeHint": "Given by whoever installed CloudServer (BOOTSTRAP_CODE).",
  "organization": "Organization name",
  "name": "Your name",
  "email": "E-mail",
  "password": "Password (optional)",
  "passwordHint": "At least 12 characters. You can sign in with a passkey only and leave this empty.",
  "submit": "Create account"
}
